import React, { useContext, useEffect, useState } from "react";
import useMasterData from "../../Hooks/useMasterData";
import { AppContext } from "../../../AppContext";
import moment from "moment";
import { ROLES } from "../../../Routes/routes";
import { calculateDefaultSession, showToast } from "../../../utils/utility";
import * as XLSX from "xlsx";
import { usePeriodicAssessment } from "../../../libs/data-access";

const useStudentWisePeriodicAssessment = () => {
  const { user, role } = useContext(AppContext);
  const {
    getDistrictByStateId,
    districts,
    getBlocksByDistrictId,
    blocks,
    getSession,
    sessions,
    classes,
    getClasses,
    getSubject,
    subjectList,
    assessmentTypes,
    getAssessmentTypes,
  } = useMasterData();

   const { fetchPeriodicAssessmentReport } = usePeriodicAssessment();

  const [selectedDistrict, setSelectedDistrict] = useState<string | undefined>(
    undefined,
  );
  const [selectedBlock, setSelectedBlock] = useState<string | undefined>(
    undefined,
  );

  const [selectedSession, setSelectedSession] = useState<string | undefined>(
    parseInt(moment().format("MM"), 10) > 4
      ? moment().add(1, "year").format("YYYY")
      : moment().format("YYYY"),
  );

  const [studentwisePeriodicData, setStudentwisePeriodicData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [grade, setGrade] = useState<any>(undefined);
  const [subject, setSubject] = useState<any>(undefined);
  const [assessmentId, setAssessmentId] = useState<any>(undefined);


 const downloadExcel = () => {
   const fixedKeys = [
     "district_Name",
     "block_Name",
     "cluster_School_Name",
     "school_Code",
     "school_Name",
     "student_Name",
     "section_Name",
     "srn_No",
     "subject_Name",
     "word_Read_Per_Minute",
     "competent_Count",
     "nonCompetent_Count",
     "partiallyCompetent_Count",
   ];

   // Get all dynamic assessment/competency keys
   const dynamicKeys = Array.from(
     new Set(
       studentwisePeriodicData.flatMap((item: any) =>
         Object.keys(item).filter((key) => !fixedKeys.includes(key)),
       ),
     ),
   );

   const excelData = studentwisePeriodicData.map((item: any) => {
     const row: any = {
       "District Name": item.district_Name,
       "Block Name": item.block_Name,
       "Cluster School Name": item.cluster_School_Name,
       "School Code": item.school_Code,
       "School Name": item.school_Name,
       "Subject Name": item.subject_Name,
       "Section Name": item.section_Name,
       "Student Name": item.student_Name,
       "SRN No.": item.srn_No,
       "Competent Count": item?.competent_Count,
       "Not Competent Count": item?.nonCompetent_Count,
       "Partially Competent Count": item?.partiallyCompetent_Count,
       "Word Read Per Minute": item?.word_Read_Per_Minute,
     };

     // Add dynamic competency columns
     dynamicKeys.forEach((key:any) => {
       row[key] = item[key];
     });

     return row;
   });

   const worksheet = XLSX.utils.json_to_sheet(excelData);

   const workbook = XLSX.utils.book_new();

   XLSX.utils.book_append_sheet(workbook, worksheet, "Student Assessment");

   XLSX.writeFile(
     workbook,
     `Student_Wise_Periodic_Assessment_${moment().format("DD-MM-YYYY")}.xlsx`,
   );
 };

 const handleApplyFilter = async () => {
   try {
     setIsLoading(true);

     const payload = {
       districtId: selectedDistrict ? +selectedDistrict : 0,
       blockId: selectedBlock ? +selectedBlock : 0,
       sessionId: selectedSession ? +selectedSession : null,
       classId: grade,
       subjectId: subject,
       assessmentId: assessmentId,
     };

     const response = await fetchPeriodicAssessmentReport(
       `PA_Result_StudentWise/${payload?.districtId}/${payload?.blockId}/${payload?.classId}/${payload?.subjectId}/${payload?.sessionId}/${payload?.assessmentId}`,
     );
     const data = response?.data || [];

      if (response?.isSuccess) {
        if (data?.length === 0) {
          showToast({
            type: "error",
            message: "No records found for the selected filters",
          });
            setStudentwisePeriodicData([]);
        } else {
         setStudentwisePeriodicData(data);
        }
      } else {
        showToast({
          type: "error",
          message: response?.message || "Failed to download report",
        });
      }
   } catch (error) {
     console.error(error);
     setStudentwisePeriodicData([]);
   } finally {
     setIsLoading(false);
   }
 };


  useEffect(() => {
    if (selectedDistrict) getBlocksByDistrictId(+selectedDistrict);
  }, [selectedDistrict]);

  useEffect(() => {
      grade && getSubject();
    }, [grade]);

    //   useEffect(() => {
    //     if(grade==15){
    // let subjectId = subjectList
    //   ?.filter((e) => e?.id === 4)
    //   ?.map((e) => e.id.toString());
    // setSubject(subjectId);
    //     }else{
    // let subjectId = subjectList?.filter((e) => e?.id != 4)?.map((e) => String(e?.id))
    // setSubject(subjectId);
    //     }
        
    //   }, [subjectList]);

  useEffect(() => {
    getDistrictByStateId(1);
    getSession(false);
     getClasses();
     getAssessmentTypes();
    if (role?.includes(ROLES.BLOCK)) {
      setSelectedDistrict(String(user?.details?.blockUserDetails?.district_Id));
      setSelectedBlock(String(user?.details?.blockUserDetails?.block_Id));
    } else if (role?.includes(ROLES.DISTRICT)) {
      setSelectedDistrict(
        String(user?.details?.districtUserDetails?.district_Id),
      );
    }
  }, []);

  useEffect(() => {
    if (sessions?.length > 0) {
      const sessionId = sessions?.find(
        (option) =>
          option?.session_Name ==
          calculateDefaultSession(parseInt(moment().format("M"))),
      )?.session_Id;
      setSelectedSession(String(sessionId));
    }
  }, [sessions]);
  return {
    selectedDistrict,
    setSelectedDistrict,
    selectedBlock,
    setSelectedBlock,
    selectedSession,
    setSelectedSession,
    districts,
    blocks,
    sessions,
    studentwisePeriodicData,
    isLoading,
    handleApplyFilter,
    grade,
    setGrade,
    subject,
    setSubject,
    subjectList,
    classes,
    assessmentTypes,
    setAssessmentId,
    assessmentId,
    downloadExcel,
  };
};

export default useStudentWisePeriodicAssessment;
